import { FIELD_TYPE } from "types/enums";
import React from "react";
import { formatToCurrencyType } from "helper/common";

const columnsTable: any = [
  // {
  //   title: "STT",
  //   dataIndex: "stt",
  //   key: "stt",
  //   width: "40px",
  //   render: (text, record, index) => index + 1,
  //   align: "center",
  // },
  {
    title: "Mã bệnh nhân",
    dataIndex: "maBenhNhan",
    key: "maBenhNhan",
    // width: '100px',
    align: "center",
  },
  {
    title: "Mã phiếu khám",
    dataIndex: "maPhieuKham",
    key: "maPhieuKham",
    // width: '100px',
    align: "center",
  },
  {
    title: "Tên bệnh nhân",
    dataIndex: "tenBenhNhan",
    key: "tenBenhNhan",
    // width: '8%',
    align: "left",
  },
  {
    title: "Số phiếu thu",
    dataIndex: "soPhieuThu",
    key: "soPhieuThu",
    // width: '100px',
    align: "center",
  },
  {
    title: "Thời gian",
    dataIndex: "thoiGian",
    key: "thoiGian",
    // width: '8%',
    align: "center",
  },
  {
    title: "Người thu",
    dataIndex: "nguoiThu",
    key: "nguoiThu",
    // width: '100px',
    align: "left",
  },
  {
    title: "Trạng thái hoá đơn",
    dataIndex: "trangThaiHoaDon",
    key: "trangThaiHoaDon",
    // width: '8%',
    align: "left",
  },
  {
    title: "Dịch vụ",
    dataIndex: "dichVus",
    key: "dichVus",
    // width: '100px',
    align: "left",
    render: (text) => (
      <span>
        {text?.split("\n").map((item, index) => (
          <span key={index}>
            {item}
            <br />
          </span>
        ))}
      </span>
    ),
  },
  {
    title: "Tổng thành tiền",
    dataIndex: "tongThanhTienDichVu",
    key: "tongThanhTienDichVu",
    // width: '8%',
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Số tiền miễn giảm",
    dataIndex: "tongTienMienGiam",
    key: "tongTienMienGiam",
    // width: '100px',
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Lý do",
    dataIndex: "lyDos",
    key: "lyDos",
    // width: '8%',
    align: "left",
    render: (text) => (
      <span>
        {text?.split("\n").map((item, index) => (
          <span key={index}>
            {item}
            <br />
          </span>
        ))}
      </span>
    ),
  },
  {
    title: "Số tiền thực thu",
    dataIndex: "soTienThucThu",
    key: "soTienThucThu",
    // width: '100px',
    align: "right",
  },
  {
    title: "Hình thức thanh toán",
    dataIndex: "hinhThucThanhToan",
    key: "hinhThucThanhToan",
    align: "left",
  },
];

export { columnsTable };
